<template>
    <div class="page-container">
        <div class="fixed-header">
            <!-- <Content /> -->
            <div class="content-top">
                <div class="const-a">
                    <div class="content-top-left">
                        <img src="../assets/images/ap-1.png" alt="" @click="goToHome">
                    </div>
                    <!-- 顶部标题 -->
                    <div class="content-top-right">
                        <div class="text-a knowledge-points-title" :class="{ active: currentSubject === 'calculus' }"
                            @click="goToCalculusBC">
                            Calculus BC</div>
                        <div class="text-a" :class="{ active: currentSubject === 'microeconomics' }"
                            @click="goToMicroeconomics">Microeconomics</div>
                        <div class="text-a" :class="{ active: currentSubject === 'macroeconomics' }"
                            @click="goToMacroeconomics">Macroeconomics</div>
                        <div class="text-a" :class="{ active: currentSubject === 'physics' }" @click="goToPhysics1">
                            Physics1</div>
                        <div class="text-a" :class="{ active: currentSubject === 'biology' }" @click="goToBiology">
                            Biology</div>
                        <div class="text-a" :class="{ active: currentSubject === 'csp' }" @click="goToCSP">CSP</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="scrollable-content">
            <div class="nav-container4">
                <div class="nav-4">
                    <div>

                        <!-- 渲染字段questionName -->
                        {{ questionName || "暂无数据" }}
                    </div>
                </div>
            </div>
            <div class="nav-container-s-l">
       
                <div v-if="questionType === '1'" class="nav-h">
                    
                        <VuePdfEmbed :source="fullPdfUrl" />
                </div>


            </div>

        </div>

        <Concat />

    </div>
</template>

<script setup>
import Concat from '../components/Concat.vue'
// import { PdfWithThumbnails } from 'vue3-pdfjs-viewer'
import VuePdfEmbed from 'vue-pdf-embed'
import { useRoute } from 'vue-router';
import { ref, onMounted, computed } from 'vue';
import router from '@/router';
// import PDFView from './PDFView.vue';
const pdfUrl = 'https://question-bank-hao.obs.cn-southwest-2.myhuaweicloud.com/2025/08/20/7d70d0e943034605b1aab2b89d9abfa8.pdf'


const imgurl = 'https://question-bank-hao.obs.cn-southwest-2.myhuaweicloud.com'
const route = useRoute()

// 定义响应式数据
const questionName = ref('')
const questionAddress = ref('')
const questionImage = ref('')
const questionNotes = ref('')
const questionType = ref('')
const currentSubject = ref('calculus')

// 计算完整的PDF URL
const fullPdfUrl = computed(() => {
    if (questionAddress.value) {
        // 如果已经是完整URL，则直接返回
        if (questionAddress.value.startsWith('http')) {
            return questionAddress.value
        }
        // 否则拼接基础URL
        return imgurl + questionAddress.value
    }
    return ''
})

onMounted(() => {
    // 从路由参数中获取数据
    const id = route.query.id
    questionAddress.value = route.query.questionAddress || ''
    questionImage.value = route.query.questionImage || ''
    questionName.value = route.query.questionName || ''
    questionNotes.value = route.query.questionNotes || ''
    questionType.value = route.query.questionType || ''

    // 使用这些参数进行渲染
})

// PDF加载事件
const onPdfLoad = () => {
    console.log('PDF加载成功')
}

const onPdfError = (error) => {
    console.error('PDF加载失败:', error)
    console.log('PDF URL:', fullPdfUrl.value)
}

// 页面导航函数
const goToHome = () => {
    router.push('/')
}

const goToMicroeconomics = () => {
    currentSubject.value = 'microeconomics'
    router.push({
        path: '/calculusbc',
        query: { subject: 'microeconomics' }
    })
}

const goToBiology = () => {
    currentSubject.value = 'biology'
    router.push({
        path: '/calculusbc',
        query: { subject: 'biology' }
    })
}

const goToPhysics1 = () => {
    currentSubject.value = 'physics'
    router.push({
        path: '/calculusbc',
        query: { subject: 'physics' }
    })
}

const goToCSP = () => {
    currentSubject.value = 'csp'
    router.push({
        path: '/calculusbc',
        query: { subject: 'csp' }
    })
}

const goToMacroeconomics = () => {
    currentSubject.value = 'macroeconomics'
    router.push({
        path: '/calculusbc',
        query: { subject: 'macroeconomics' }
    })
}

const goToCalculusBC = () => {
    currentSubject.value = 'calculus'
    router.push({
        path: '/calculusbc',
        query: { subject: 'calculus' }
    })
}

</script>

<style scoped>
::v-deep .pdfjs-toolbar-right{
    button{
        background:#ccc;
    }
}
::v-deep .pdfjs-thumbnail{
    display: none;
}
::v-deep .pdfjs-toolbar-left{
    display: none;
}
::v-deep .pdf-main-canvas{
    display: flex;
    flex-direction: column;
    align-items: center;
}
::v-deep .pdf-annotation-layer{}
/* -----顶部标题样式--- */
.knowledge-points-title {
    white-space: nowrap;
}

/* .fixed-header {
    flex-shrink: 0;
} */

.content-top {
    width: 1440px;
    height: 100px;
    width: 100vw;
    background-color: black;
    height: 100px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

.const-a {
    width: 1200px;
    height: 100px;
    display: flex;
    align-items: center;
}

.content-top-left {
    width: 202px;
    height: 44px;
    margin-right: 108px;
}

.content-top-left img {
    width: 202px;
    height: 44px;
    cursor: pointer;
}

.content-top-right {
    width: 890px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.text-a {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 22px;
    color: #FFFFFF;
    margin-right: 39px;
    cursor: pointer;
}

.text-a.active {
    text-decoration: underline;
}

/* ----------- */
.page-container {
    display: flex;
    flex-direction: column;
    /* height: 100vh; */
}

.fixed-header {
    flex-shrink: 0;
}

.scrollable-content {
    flex: 1;
    overflow-y: auto;
    max-height: 1732px;
}

.no-pdf {
    text-align: center;
    padding: 40px;
    height: 800px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.no-pdf p {
    font-family: PingFang SC;
    font-size: 18px;
    color: #666;
}

/* 
.fixed-footer {
    flex-shrink: 0;
} */
.nav-container-s-l {
    width: 100vw;
    display: flex;
    justify-content: center;
    /* 水平居中 */
    border: none !important; /* 强制去掉所有边框 */

    .nav-h {
        height: 1818px;
        width: 1200px;
        margin: 40px 120px 60px 120px;
        /* border: 1px solid red; */
        padding: 1px;
        font-size: 20px;
        background-color:#f7f7f7;
        padding: 30px;
    }
}

@import '../pages/index-d-pdf.css'
</style>